import { PageRoots, UrlSegments } from '@provision/portal-routes';
import { Navigate, Route } from 'react-router-dom';
import { CRM } from 'src/pages';
import { getRoutePath } from 'src/routes/utils';

const CrmRedirectPlaceholder = () => null;

export const CrmRoutes = ({ relative }: { relative?: boolean }) => (
  <Route path={getRoutePath(PageRoots.crm, relative)} element={<CRM />}>
    <Route path="*" element={<CrmRedirectPlaceholder />} />
    <Route
      index
      element={<Navigate to={getRoutePath(UrlSegments.crm.organizations, relative)} replace />}
    />
  </Route>
);
